import {IPoint} from '@consts/types'

type LineSegment = IPoint[];

type Point2fType = '-' | '*' | '+' | '/';

const point2f = (start: IPoint, type: Point2fType, end: IPoint): IPoint => {
  switch(type) {
    case '-':
      return {x: start.x - end.x, y: start.y - end.y}
    case '+':
      return {x: start.x + end.x, y: start.y + end.y}
    case '*':
      return {x: start.x * end.x, y: start.y * end.y}
    case '/':
      return {x: start.x / end.x, y: start.y / end.y}
  }
}


export default (firstLine: LineSegment, secondSegment:LineSegment) => {
  const [start1, end1] = firstLine;
  const [start2, end2] = secondSegment;

  const dir1 = point2f(end1, '-', start1);
  const dir2 = point2f(end2, '-', start2);

  const a1 = -dir1.y;
  const b1 = +dir1.x;
  const d1 = -(a1*start1.x + b1*start1.y);

  const a2 = -dir2.y;
  const b2 = +dir2.x;
  const d2 = -(a2*start2.x + b2*start2.y);

  const seg1_line2_start = a2*start1.x + b2*start1.y + d2;
  const seg1_line2_end = a2*end1.x + b2*end1.y + d2;

  const seg2_line1_start = a1*start2.x + b1*start2.y + d1;
  const seg2_line1_end = a1*end2.x + b1*end2.y + d1;
  
  if (seg1_line2_start * seg1_line2_end >= 0 || seg2_line1_start * seg2_line1_end >= 0) {
    return false;
  }

  const u = seg1_line2_start / (seg1_line2_start - seg1_line2_end);
  const pin_out = point2f({x: u, y: u}, '*', dir1);
  return point2f(start1, '+', pin_out);
}